import tinycolor from "tinycolor2"

import { DEFAULT_COLOR_LIGHT_PRIMARY } from "../../../../../lib/muiTheme"
import { Box, Typography } from "@podcastsoundboard/ps-lib/ui"
import Keyboard from "@podcastsoundboard/ps-lib/ui/icons/Keyboard"
import MusicNote from "@podcastsoundboard/ps-lib/ui/icons/MusicNote"

export default function Shortcut({
  shortcut,
  color,
  isMidi,
  reduceTextSize,
}: {
  shortcut: string
  color: string
  isMidi?: boolean
  reduceTextSize?: boolean
}) {
  const backgroundColor = color || DEFAULT_COLOR_LIGHT_PRIMARY
  const textColor = tinycolor
    .mostReadable(backgroundColor, ["#333", "#fff"])
    .toHexString()

  let fontSize = "inherit"
  switch (reduceTextSize) {
    case true:
      fontSize = "1rem"
      if (shortcut && shortcut.length > 3) {
        fontSize = "0.85rem"
      }
      if (shortcut && shortcut.length > 5) {
        fontSize = "0.7rem"
      }
      break
    default:
      fontSize = "1.1rem"
      if (shortcut && shortcut.length > 3) {
        fontSize = "0.9rem"
      }
      if (shortcut && shortcut.length > 5) {
        fontSize = "0.75rem"
      }
  }

  return (
    <Box
      style={{
        opacity: shortcut ? 1 : 0.5,
        cursor: "pointer",
        border: `1px solid ${color || DEFAULT_COLOR_LIGHT_PRIMARY}`,
        borderRadius: "0.2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor,
      }}
      className="h-6 px-1"
    >
      {shortcut && (
        <>
          {isMidi ? (
            <MusicNote fontSize="small" style={{ color: textColor }} />
          ) : (
            <Keyboard fontSize="small" style={{ color: textColor }} />
          )}
          <Typography
            variant="h4"
            fontSize={fontSize}
            className="p-0 m-0 leading-none"
            style={{ textTransform: "uppercase", color: textColor }}
          >
            {shortcut}
          </Typography>
        </>
      )}

      {!shortcut && (
        <Typography variant="body1" fontSize="0.75rem">
          BIND
        </Typography>
      )}
    </Box>
  )
}
